import {
  SET_MEDIA_SERVICE_CONFIG,
  SET_MEDIA_SERVICE_LOADING,
  SET_MEDIA_SERVICE_ERROR,
  SET_MEDIA_SERVICE_VALIDATION
} from '../actions/mediaService.actions';

const initialState = {
  config: null,
  loading: false,
  error: null,
  validationResult: { loading: false, valid: null, version: null, error: null }
};

const mediaServiceReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_MEDIA_SERVICE_CONFIG:
      return { ...state, config: action.payload, error: null };
    case SET_MEDIA_SERVICE_LOADING:
      return { ...state, loading: action.payload };
    case SET_MEDIA_SERVICE_ERROR:
      return { ...state, error: action.payload };
    case SET_MEDIA_SERVICE_VALIDATION:
      return { ...state, validationResult: action.payload };
    default:
      return state;
  }
};

export default mediaServiceReducer;
